import Front from '@frontapp/plugin-sdk';
import {
  createContext,
  type ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';

/*
 * Context.
 */
type InboxT = {
  id: string;
  ownerId: string;
  name: string;
};

type ContactT = {
  customAttributes: { [key: string]: string }[];
  description?: string;
  id: string;
  name: string;
};
type ConversationT = {
  id: string;
  inboxes: InboxT[];
  recipient: {
    name: string;
    handle: string;
    type: string;
    contact: ContactT;
  };
  status: string;
  subject: string;
  tags: string[];
  type: string;
};

type TeammateT = {
  eemail: string;
  id: string;
  name: string;
  username: string;
};

type MessageT = {
  id: string;
  date: Date;
};

type FrontContextT = {
  type: string;
  conversation: ConversationT;
  teammate: TeammateT;
  listMessages: (
    paginationToken?: string,
  ) => Promise<{ nextPageToken: string; results: MessageT[] }>;
  openUrl: (url: string) => Promise<void>;
  openUrlInPopup: (url: string) => Promise<void>;
};
export const FrontContext = createContext<FrontContextT | null>(null);

/*
 * Hook.
 */

export function useFrontContext() {
  return useContext(FrontContext);
}

/*
 * Component.
 */

type Props = {
  children: ReactNode;
};

export const FrontContextProvider = ({ children }: Props) => {
  const [context, setContext] = useState<any>();

  useEffect(() => {
    const subscription = Front.contextUpdates.subscribe((frontContext) => {
      setContext(frontContext);
    });
    return () => subscription.unsubscribe();
  }, []);

  return (
    <FrontContext.Provider value={context}>{children}</FrontContext.Provider>
  );
};
